import { render } from "./AdminSideBar.vue?vue&type=template&id=28b048e9&scoped=true"
import script from "./AdminSideBar.vue?vue&type=script&lang=js"
export * from "./AdminSideBar.vue?vue&type=script&lang=js"

import "./AdminSideBar.vue?vue&type=style&index=0&id=28b048e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b048e9"]])

export default __exports__